import { lazy } from "react";
import { addHandleRoute, createRoute } from "../utils/RouteHelper";

// route
export const mitraSCMRoute = createRoute({
    path: "/mitra",
    name: "mitra.",
    icon: "people",
    accCode: "mitra_scm_online",
    exclude_breadcrumbs: true,
});

export const mitraSearchRoute = createRoute({
    path: `${mitraSCMRoute.path}/search`,
    name: "mitra.menu.search",
    accCode: "mitra_scm_online_cari_mitra",
    parentCode: mitraSCMRoute.accCode,
});

export const mitraConfirmationRoute = createRoute({
    path: `${mitraSCMRoute.path}/confirmation`,
    name: "mitra.menu.confirmation",
    accCode: "",
    parentCode: mitraSCMRoute.accCode,
});

export const mitraListRoute = createRoute({
    path: `${mitraSCMRoute.path}/list`,
    name: "mitra_list.",
    accCode: "mitra_scm_online_daftar_mitra",
    parentCode: mitraSCMRoute.accCode,
});

export const mitraProductListRoute = createRoute({
    path: `${mitraListRoute.path}/product_list`,
    name: "mitra.menu.product",
    accCode: "mitra_scm_online_permintaan_barang",
    parentCode: mitraSCMRoute.accCode,
});

export const mitraOwnProductListRoute = createRoute({
    path: `${mitraListRoute.path}/own_product_list`,
    name: "mitra.menu.product_own",
    accCode: "",
    parentCode: mitraSCMRoute.accCode,
});

export const mitraStockReqRoute = createRoute({
    path: `${mitraSCMRoute.path}/stock_request`,
    name: "mitra_stock_req.",
    accCode: "",
    parentCode: mitraSCMRoute.accCode,
});

export const mitraAddStckReqRoute = createRoute({
    path: `${mitraStockReqRoute.path}/add`,
    name: "mitra_stock_req.add",
    accCode: "",
    parentCode: mitraSCMRoute.accCode,
    action: "create",
    redirectTo: mitraStockReqRoute.path,
});

export const mitraEditStckReqRoute = createRoute({
    path: `${mitraStockReqRoute.path}/edit`,
    name: "mitra_stock_req.edit",
    accCode: "",
    parentCode: mitraSCMRoute.accCode,
    action: "edit",
    redirectTo: mitraStockReqRoute.path,
});

export const mitraViewStckReqRoute = createRoute({
    path: `${mitraStockReqRoute.path}/view`,
    name: "mitra_stock_req.detail",
    accCode: "",
    parentCode: mitraSCMRoute.accCode,
});

export const mitraDOOutStckReqRoute = createRoute({
    path: `${mitraStockReqRoute.path}/do_out`,
    name: "mitra_stock_req.do_out",
    accCode: "",
    parentCode: mitraSCMRoute.accCode,
});

export const mitraDOInStckReqRoute = createRoute({
    path: `${mitraStockReqRoute.path}/do_in`,
    name: "mitra_stock_req.do_in",
    accCode: "",
    parentCode: mitraSCMRoute.accCode,
});

// component
const MitraSCM = lazy(() => import("../page/mitra/MitraSCM"));
const MitraSCM2 = lazy(() => import("../page/mitra/MitraSCM2"));
const MitraSearch = lazy(() => import("../page/mitra/search/MitraSearch"));
const MitraConfirmation = lazy(() => import("../page/mitra/confirmation/MitraConfirmation"));
const MitraList = lazy(() => import("../page/mitra/list/MitraList"));
const MitraProductList = lazy(() => import("../page/mitra/list/MitraProductList"));
const MitraOwnProductList = lazy(() => import("../page/mitra/list/MitraOwnProductList"));
const MitraStockRequest = lazy(() => import("../page/mitra/stock_request/MitraStockRequest"));
const MitraFromStockRequest = lazy(() => import("../page/mitra/stock_request/form/MitraFromStockReq"));
const MitraViewStockRequest = lazy(() => import("../page/mitra/stock_request/view/MitraViewStockReq"));
const MitraDOOutStockRequest = lazy(() => import("../page/mitra/stock_request/form_do_out/MitraStockReqDOOutForm"));
const MitraDOInStockRequest = lazy(() => import("../page/mitra/stock_request/form_do_in/MitraStockReqDOInForm"));

export const mitraTabRoute = [mitraSearchRoute, mitraConfirmationRoute];
export const mitraListRoutes = [mitraSearchRoute, mitraListRoute, mitraStockReqRoute];
export const mitraMutationRutes = [
    mitraListRoute, mitraStockReqRoute,
    mitraAddStckReqRoute, mitraEditStckReqRoute, mitraViewStckReqRoute,
    mitraDOOutStckReqRoute, mitraDOInStckReqRoute,
    mitraProductListRoute, mitraOwnProductListRoute,
]

export const mitarSCMRoutes = [
    {
        element: <MitraSCM />,
        children: addHandleRoute([
            { ...mitraSearchRoute, element: <MitraSearch /> },
            { ...mitraConfirmationRoute, element: <MitraConfirmation /> },
        ]),
    },
    {
        element: <MitraSCM2 />,
        children: addHandleRoute([
            { ...mitraListRoute, element: <MitraList /> },
            { ...mitraProductListRoute, element: <MitraProductList /> },
            { ...mitraOwnProductListRoute, element: <MitraOwnProductList /> },
            { ...mitraStockReqRoute, element: <MitraStockRequest /> },
            { ...mitraAddStckReqRoute, element: <MitraFromStockRequest /> },
            { ...mitraEditStckReqRoute, element: <MitraFromStockRequest /> },
            { ...mitraViewStckReqRoute, element: <MitraViewStockRequest /> },
            { ...mitraDOInStckReqRoute, element: <MitraDOInStockRequest /> },
            { ...mitraDOOutStckReqRoute, element: <MitraDOOutStockRequest /> },
        ]),
    }
];